import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { ATTENDANCE_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { JobCardPage } from '@/features/attendance/pages/JobCardPage';
import { downloadJobCard, jobCardQueryOptions } from '@/features/attendance/api/attendance.api';
import { jobCardSearchSchema } from '@/features/attendance/types/attendance.types';

export const Route = createFileRoute('/_auth/attendance/job-card')({
  beforeLoad: () => requirePermission(ATTENDANCE_PERMISSIONS.JOB_CARD_VIEW),
  validateSearch: jobCardSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Job Card">
      <Suspense fallback={<PageLoader />}>
        <JobCardPage
          queryOptions={jobCardQueryOptions}
          onExport={downloadJobCard}
          title="Job Card Dashboard"
          selfRoute="/attendance/job-card"
          employeeReportRoute="/attendance/employee-report"
        />
      </Suspense>
    </ErrorBoundary>
  ),
});
